// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 11 13" {...rest} unit={unit}>
		<g id="Player-Cell/Action/Release"
			transform="translate(-25.000000, -24.000000)">
			<path d="M29.1964286,24 C32.7857143,24 35.2946429,26.5892857 35.2946429,
			30.3125 L35.2946429,30.6964286 C35.2946429,34.4196429 32.7857143,
			37 29.2232143,37 L25,37 L25,24 L29.1964286,24 Z M31.8660714,
			30.6964286 L31.8660714,30.2946429 C31.8660714,
			27.8839286 30.9910714,26.7142857 29.1964286,
			26.7142857 L28.3660714,26.7142857 L28.3660714,
			34.3035714 L29.2232143,34.3035714 C30.9821429,
			34.3035714 31.8660714,33.125 31.8660714,30.6964286 Z" id="D"></path>
    	</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/D.js